// =============================================================================
//          (c) Copyright 2021 by Brinks Home Security | Dallas, TX, USA
// =============================================================================
// Version   : 0.1.1
// Created at: 09.28.16
// Project   : Brinks Home Security Shared Assets
// -----------------------------------------------------------------------------
// Helpers to support JS page navigation and other page-specific view logic
// -----------------------------------------------------------------------------

const PageHelper = (($) => {
  const Selectors = {
    NAVBAR_MAIN: '#js-navbar-main'
  }

  /* --------------------------------------------------------------------------
    Public
  -------------------------------------------------------------------------- */

  let PageHelper = {
    // Add `.active` class to any link in the main navbar for which the
    // initial subdir of the href attribute matches the initial subdir of the
    // current URL.
    initMainNavLinkState () {
      // Get subdir parts (up to 2 levels deep)
      const activePath = location.pathname.split('/', 3).splice(1, 2)
      const activeSubdirs = activePath.join('/')

      if (activeSubdirs) {
        $(`${Selectors.NAVBAR_MAIN} .nav-link[href^='/${activeSubdirs}']`).addClass('active')
      }
    }
  }

  return PageHelper
})(jQuery)

export default PageHelper
